<template>
  <BaseInputModal
    v-model:show="globalModal.showTextInputModal"
    :title="globalModal.textInputTitle"
    :description="globalModal.textInputDescription"
    :text="globalModal.textInputInitValue"
    @confirm="clickConfirm"
  />
</template>

<script setup lang="ts">
import { useGlobalModal } from "@/stores/globalModal";

const globalModal = useGlobalModal();

const clickConfirm = (content: string) => {
  if (!globalModal.textInputCallback) return;
  globalModal.showTextInputModal = false;
  globalModal.textInputCallback(content);
};
</script>
